import { TwilioTokenResponse, twilioToken } from '@reception-web/common/api/app'
import { AxiosError } from 'axios'
import useSWR from 'swr'

export const useTwilioTokenApi = ({
  aosToken,
}: {
  aosToken: string | null
}) => {
  const { data, error } = useSWR<TwilioTokenResponse, AxiosError<Error>>(
    aosToken ? `/aos/twilio-access-token` : null,
    () =>
      twilioToken({ headers: { Authorization: `Token ${aosToken}` } }).then(
        (res) => res.data
      )
  )

  return {
    data,
    error,
  }
}
